// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Encoded message type — enum, not string. 1 byte.
 */
export enum EncodedType {
  OneHot = 0,
  BitMask = 1,
}
